export default {
  api: {
    list: {
      method: "get",
      url: "/line/list"
    },
    create: {
      method: "post",
      url: "/user/order/create"
    },
    productLine: {
      method: "get",
      url: "/product/list"
    },
    closeAutoRenew: {
      method: "put",
      url: "/line/closeAutoRenew/{lineId}"
    },
    info: {
      method: "get",
      url: "/line/info/{lineId}"
    },
    getLineListByName: {
      method: "get",
      url: "/product/getLineListByName"
    },
    openAutoRenew: {
      method: "put",
      url: "/line/openAutoRenew"
    },
    renewLine: {
      method: "post",
      url: "/line/renewLine"
    },
    getNextRenewTime: {
      method: "post",
      url: "/line/getNextRenewTime"
    },
    closeRenew: {
      method: "put",
      url: "/line/renewLine/close/"
    }
  }
};
